import { BASE_URL_API } from "../../constants";
import fetcher from "../../utils/fetcher";

export const _api_post_task_definition = ({ ids, id_user }) => {
    const url = BASE_URL_API + "/task/task_definition/list/" + id_user;
    return fetcher(url, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
            ids,
        }),
    });
};
